/* istanbul ignore file */
// eslint-disable-next-line nebula-rules/check-exist-test-file
import uniqByLib from 'lodash-es/uniqBy';

export const uniqBy = uniqByLib;
